document.addEventListener("DOMContentLoaded", function () {
    if (document.querySelector("[data-resources-by-product-page]")) {
        import(/* webpackChunkName: "resources-by-product" */ "/Features/SupportByProduct/js/resources-by-product.js").then(async (module) => {
            const resourcesByProductPage = new module.default();
            await resourcesByProductPage.init();
        });
    }
});